import React from 'react';
import { Button } from '../../ui/primitives';
import { usePortalLanguage } from '../../../contexts/PortalLanguageContext';

// Each option is labeled in its own language, so a reader who knows only one of
// them can still find it.
const OPTIONS = [
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Español' }
];

// Two-option language toggle, pinned to the top right of the portal page.
function PortalLanguageToggle({ onChange }) {
    const { lang, t } = usePortalLanguage();
    return (
        <div
            role="group"
            aria-label={t('Language')}
            data-testid="portal-language-toggle"
            className="inline-flex items-center gap-1 rounded-full border border-[color:var(--border-color)] bg-[color:var(--surface-primary)] p-1 shadow-sm"
        >
            {OPTIONS.map(option => {
                const active = option.value === lang;
                return (
                    <Button
                        key={option.value}
                        size="sm"
                        variant={active ? 'accent' : 'ghost'}
                        lang={option.value}
                        aria-pressed={active}
                        onClick={() => { if (!active) onChange(option.value); }}
                        className={`!min-h-[36px] !rounded-full !border-0 !px-4 ${active ? '' : '!text-[color:var(--text-muted)] hover:!text-[color:var(--text-primary)]'}`}
                    >
                        {option.label}
                    </Button>
                );
            })}
        </div>
    );
}

export default PortalLanguageToggle;
